// extracted by mini-css-extract-plugin
export default {"icon_img":"ap","banner_wrapper":"bp","banner":"cp","title_wrapper":"ep","icons":"fp","weekly_freq":"gp","icon":"hp","icon_title":"ip"};
    if(module.hot) {
      // 1713809675602
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  